import { Membership, PaymentOptionType } from '@wix/ambassador-totals-calculator/http';
import { PaymentMethod } from '../../../types/types';
import { AddOnPaymentOptions } from '@wix/ambassador-bookings-services-v2-service/types';

export const getPaymentOption = (
  selectedPaymentType: PaymentMethod,
  deposit: Maybe<number>,
  selectedMembership?: Membership,
  addonsPaymentOptions?: AddOnPaymentOptions,
  isAddonsWithPlanOnlyUOUEnabled?: boolean,
) => {
  if (deposit) {
    return PaymentOptionType.DEPOSIT_ONLINE;
  } else if (selectedMembership) {
    if (isAddonsWithPlanOnlyUOUEnabled && 
      addonsPaymentOptions === AddOnPaymentOptions.IN_PERSON) {
      return PaymentOptionType.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER;
    }
    return PaymentOptionType.MEMBERSHIP
  } else {
    return selectedPaymentType === PaymentMethod.ONLINE
      ? PaymentOptionType.FULL_PAYMENT_ONLINE
      : PaymentOptionType.FULL_PAYMENT_OFFLINE;
  }
};
